export const build = {"version":"1.2.0-261105-0933"};
